export enum AssetStatus {
  CREATED = 'created',
  PENDING = 'pending',
  FAILED = 'failed',
  ARCHIVED = 'archived',
}
